import * as React from 'react';
import {AppBar, Toolbar, Box, Avatar, Badge, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';

import CustomBackdrop from './CustomBackdrop';
import SidebarDrawer from './TemporaryDrawer';
import Swal from 'sweetalert2';

//ICONOS
import { Logout, Person } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../hooks/context/AuthProvider';
import imgLogo from '../assets/png/nopala_logo.png';

export default function Navbar() { 

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);//ESTADO DE MENU LATERAL
  const [openBackdrop, setOpenBackdrop] = React.useState(false);//ESTADO VENTANA DE CARGA
  const { user, logout } = useAuth();

  const isAuthenticated = !!user; // AUTH DINÁMICO
  const handleClose = () => setAnchorEl(null);//CERRAR MENU
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  
  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);
  const handleCloseDialog = () => handleClose();

  const logOut = () => {
      Swal.fire({
          title: "CERRAR SESIÓN",  
          text: "¿ESTAS SEGURO DE CERRAR SESIÓN?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "SI, CONFIRMAR",
          confirmButtonColor: "#783938",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async(result) => {
          handleCloseDialog();
          setOpenBackdrop(true);
          if (result.isConfirmed) { 
          const response = await logout();
          if (response.success) {
              Swal.fire({
                toast: true,
                position: 'top-start',
                icon: 'success',
                title: `HASTA PRONTO ${user?.username || 'UKNOW'}`,
                text: 'SESIÓN CERRADA CON EXITO',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                background: '#1f2933',
                color: '#fff',
                iconColor: '#22c55e'
              });
          }else{
            Swal.fire({
                title: '¡ERROR! ❌',
                icon: 'error',
                text: 'NO SE PUDO CERRA LA SESION',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }
          }
          setOpenBackdrop(false);
        }
      )
    }

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: 'linear-gradient(180deg, #833c3cff 20%, #3b1e1eff 100%)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <Toolbar sx={{ height: 80, px: { xs: 2, sm: 4 } }}>
          {/* BOTON MENU */}
          {isAuthenticated && (
            <IconButton
              edge="start"
              onClick={handleDrawerOpen}
              sx={{
                mr: 2,
                color: 'white',
                background: 'rgba(255, 255, 255, 0.15)',
                '&:hover': { background: 'rgba(255, 255, 255, 0.25)' },
                transition: 'all 0.3s ease',
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* IMAGEN LOGO */}
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              ml: { xs: 0, sm: 2 },
            }}
          >
            <Box
              component="img"
              src={imgLogo}
              alt="Logo"
              sx={{
                height: 60,
                width: 'auto',
                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            />
          </Box>

          {/* USUARIO CON AVATAR*/}
          {isAuthenticated && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {/* INFORMACION DEL USUARIO */}
              <Box sx={{ textAlign: 'right', color: 'white' }}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  sx={{
                    textShadow: '0 1px 3px rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                  }}
                >
                  <Person sx={{ fontSize: 18 }} />
                  {user?.username || 'UKNOW'}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#e0e7ff',
                    fontWeight: 500,
                    letterSpacing: 0.5,
                    textShadow: '0 1px 2px rgba(0,0,0,0.4)',
                  }}
                >
                  {user?.role || 'UKNOW'}
                </Typography>
              </Box>

              {/* AVATAR CON BADEGE Y MENU */}
              <IconButton
                onClick={handleMenu}
                sx={{
                  p: 0.5,
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'white',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
                  },
                }}
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  variant="dot"
                  sx={{
                    '& .MuiBadge-badge': {
                      backgroundColor: '#44b700',
                      color: '#44b700',
                      boxShadow: '0 0 0 3px #af1e23ff',
                      width: 14,
                      height: 14,
                      borderRadius: '50%',
                      animation: 'pulse 2s infinite',
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      width: 48,
                      height: 48,
                      border: '3px solid white',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    }}
                  >
                  {user?.username?.[0]?.toUpperCase() || 'U'}
                  </Avatar>
                </Badge>
              </IconButton>

              {/* MENU DESPLEGABLE */}
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                  elevation: 8,
                  sx: {
                    mt: 1.5,
                    minWidth: 200,
                    borderRadius: 2,
                    background: 'linear-gradient(180deg, #833c3cff 20%, #3b1e1eff 100%)',
                    color: 'white',
                    '& .MuiMenuItem-root': {
                      py: 1.5,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.15)',
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={logOut} sx={{ gap: 1 }}>
                  <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  <Typography fontWeight="medium">Cerrar Sesión</Typography>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>

        {/* ANIMACION DEL PUNTO ONLINE EN EL AVATAR */}
        <style jsx>{`
          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(68, 183, 0, 0.7);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(68, 183, 0, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(68, 183, 0, 0);
            }
          }
        `}</style>
      </AppBar>
      {/* <TemporaryDrawer open={drawerOpen} onClose={handleDrawerClose}/> */}
      <SidebarDrawer open={drawerOpen} handleDrawerClose={handleDrawerClose} />
      <CustomBackdrop open={openBackdrop}/>
    </>
  );
}